// utils/dateUtils.js
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);


export const calculateLeadAge = (lead) => {
    if (!lead?.createdAt) return '0 Days';
    const created = new Date(lead.createdAt);
    const now = new Date();
    const diffTime = Math.abs(now - created);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} Days`;
};


// Convert any date to PST timezone
export const convertToPST = (date) => {
    if (!date) return null;

    // If date is already a dayjs object
    if (dayjs.isDayjs(date)) {
        return date.tz('America/Los_Angeles');
    }

    // If date is a string/Date object
    return dayjs(date).tz('America/Los_Angeles');
};

// Format date in PST
export const formatPSTDate = (dateString) => {
    if (!dateString) return 'N/A';
    return convertToPST(dayjs(dateString)).format('MM-DD-YYYY hh:mm A');
};